var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddInvitation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15631_7441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 1.33464V2.0013H5.33333V1.33464C5.33333 0.967969 5.03333 0.667969 4.66667 0.667969C4.3 0.667969 4 0.967969 4 1.33464V2.0013H3.33333C2.59333 2.0013 2.00667 2.6013 2.00667 3.33464L2 12.668C2 13.4013 2.59333 14.0013 3.33333 14.0013H12.6667C13.4 14.0013 14 13.4013 14 12.668V3.33464C14 2.6013 13.4 2.0013 12.6667 2.0013H12V1.33464C12 0.967969 11.7 0.667969 11.3333 0.667969C10.9667 0.667969 10.6667 0.967969 10.6667 1.33464ZM12 12.668H4C3.63333 12.668 3.33333 12.368 3.33333 12.0013V5.33464H12.6667V12.0013C12.6667 12.368 12.3667 12.668 12 12.668Z",
    fill: "#303F47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.33337,
    y: 6.66602,
    width: 1.33333,
    height: 4.66667,
    fill: "#303F47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.66663,
    y: 9.66602,
    width: 1.33333,
    height: 4.66667,
    transform: "rotate(-90 5.66663 9.66602)",
    fill: "#303F47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15631_7441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddInvitation);
export default __webpack_public_path__ + "static/media/add_invitation.afa7e771973fd02effb10bc62ed2d714.svg";
export { ForwardRef as ReactComponent };